

// 空函数
export function noop () {
}

export function loadJs (src) {
  return new Promise((resolve, reject) => {
    const ref = document.getElementsByTagName('script')[0];
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    ref.parentNode.insertBefore(script, ref);
    script.onload = resolve;
    script.onerror = reject;
  });
}

export function getCookie (name) {
  let value = '; ' + window.document.cookie;
  let parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();

  return ''
}

export function loadJs2 (url) {
  return loadJs(url).catch(() => loadJs(url));
}

export function getOrCreateLocalId () {
  if (window && window.localStorage) {
    const ls = window.localStorage;
    let deviceId = ls.getItem('deviceId');
    if (deviceId) {
      return deviceId;
    } else {
      deviceId = `${(Math.random() * 1000000).toString(16)}_${new Date().getTime()}`;
      ls.setItem('deviceId', deviceId);
      return deviceId;
    }
  } else {
    return 'no_support_localStorage';
  }
};
